import React from 'react';
import { useLocation } from 'react-router-dom';
import { resolveRouteTheme } from '@/shared/config/designTokens';
import FmThemeProvider from '@/shared/ui/FmThemeProvider';

/** Resolves the current route's theme and hands it to the route theme owner. */
export const RouteThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { pathname } = useLocation();
  return <FmThemeProvider theme={resolveRouteTheme(pathname)}>{children}</FmThemeProvider>;
};
